import { useTranslation } from "react-i18next";
import {
  CheckboxContainer,
  CheckboxText,
  CheckboxesContainer,
  Container,
  PickUpContainer,
} from "./styles";

import bigWomenClothing from "~/assets/svg/category-thumb-big-women-clothing.jpg";
import techAccessories from "~/assets/svg/category-thumb-tech-accessories.jpg";
import bathBeauty from "~/assets/svg/category-thumb-bath-beauty.jpg";
import CustomCheckbox from "~/components/ui/Checkbox";
import { Radio } from "../radio";
import CustomTooltip from "~/components/ui/Chart/customTooltip";
import { Tooltip } from "~/components/ui/Tooltip";
import { StepComponentProps } from "../steps";

const categories = [
  {
    name: "Women's Clothing",
    slug: "womens-clothing",
    label:
      "onboarding.customization-store.category.static-categories.womensclothing",
    icon: <img src={bigWomenClothing} alt="Category" width={48} height={48} />,
  },
  {
    name: "Tech Accessories",
    slug: "tech-accessories",
    label:
      "onboarding.customization-store.category.staticcategories.techaccessories",
    icon: <img src={techAccessories} alt="Category" width={48} height={48} />,
  },
  {
    name: "Bath & Beauty",
    slug: "bath-beauty",
    label:
      "onboarding.customization-store.category.static-categories.bathbeauty",
    icon: <img src={bathBeauty} alt="Category" width={48} height={48} />,
  },
];

type CategoryProps = StepComponentProps & {};

export const Category = ({
  onboardingChoices,
  setOnboardingChoices,
}: CategoryProps) => {
  const { t } = useTranslation();

  const selectedCategories = onboardingChoices?.selectedStoreCategory || [];

  const handlePickAllCategories = () => {
    if (String(selectedCategories) === "automatic") {
      return setOnboardingChoices((state) => ({
        ...state,
        selectedStoreCategory: [],
      }));
    }

    return setOnboardingChoices((state) => ({
      ...state,
      selectedStoreCategory: "automatic",
    }));
  };

  const checkIfCheckboxIsSelected = (category: string) => {
    return selectedCategories?.includes(category);
  };

  const handleSelectCategory = (value: string) => {
    let formattedValue: string | string[] = [];

    if (value === "automatic" || value === "null") {
      return (formattedValue = value);
    }

    const categoryIndex = selectedCategories.indexOf(value);
    if (categoryIndex >= 0) {
      const selectedCategoriesArray = selectedCategories as string[];
      const newSelectedCategories = selectedCategoriesArray.filter(
        (category) => category !== value
      );
      formattedValue = newSelectedCategories;
    } else {
      if (selectedCategories === "automatic" || selectedCategories === "null") {
        formattedValue = [value];
      } else {
        formattedValue = [...selectedCategories, value];
      }
    }

    setOnboardingChoices((state) => ({
      ...state,
      selectedStoreCategory: formattedValue,
    }));
  };

  return (
    <CheckboxesContainer>
      {categories.map((category) => {
        const { name: categoryName, slug: categorySlug } = category;

        const isChecked =
          checkIfCheckboxIsSelected(categoryName) ||
          String(selectedCategories) === "all";

        return (
          <CheckboxContainer
            key={`onboarding-flow-categories-${categorySlug}`}
            onClick={() => {
              handleSelectCategory(categoryName);
            }}
            checked={isChecked}>
            <CustomCheckbox
              stopPropagation
              onChange={() => handleSelectCategory(categoryName)}
              className={"onboarding-categories-checkbox"}
              checked={isChecked}
              label={categoryName}
            />
          </CheckboxContainer>
        );
      })}
      <PickUpContainer>
        <Radio
          optionId="automatic"
          isFullWidth
          context="store-region-selection"
          checked={String(selectedCategories) === "automatic"}
          label={
            <Tooltip
              message={t(
                "onboarding.customization-store.category.categories.checkbox.trending"
              )}>
              <CheckboxText
                checked={String(selectedCategories) === "automatic"}>
                {t(
                  "onboarding.customization-store.category.categories.checkbox.trending"
                )}
              </CheckboxText>
            </Tooltip>
          }
          changeSeletedOption={handlePickAllCategories}
        />
      </PickUpContainer>
    </CheckboxesContainer>
  );
};
